export default __webpack_public_path__ + "0604a4f9ee03a6f4a5d1997a3012ca09.png";